import 'slick-carousel';
import isInViewport from 'utils/IsInViewport';
import BreakpointSniffer from 'utils/BreakpointSniffer'

export default (function() {
	let _$carousel = null;
	let _$lastSlide;
	let _$nav;
	let isActive = false;

	function init($carousel) {
		_$carousel = $carousel;

		if (BreakpointSniffer.isBigger('md')) {
			start();
		}

		onResize();
		$(window).on('resize', onResize);
	}

	function start() {
		isActive = true;

		if (_$carousel.length > 0) {
			_$carousel.each(initCarousel);
		}
	}

	function initCarousel(index,carousel) {
		_$nav = $(carousel).siblings('.js-carousel-nav');

		$(carousel).slick({
			cssEase       : 'cubic-bezier(0.15, 0, 0, 1)',
			infinite      : false,
			speed         : 500,
			fade          : false,
			dots          : false,
			adaptiveHeight: false,
			swipe         : false,
			variableWidth : true,
			appendArrows: _$nav,
			prevArrow   : '<a class="slick-prev slick-arrow" href="#"><i class="icon icon-chevron-left" aria-hidden="true"></i></a>',
			nextArrow   : '<a class="slick-next slick-arrow" href="#"><i class="icon icon-chevron-right" aria-hidden="true"></i></a>'
		});

		$(carousel).on('destroy', () => {
			isActive = false;
			$(window).trigger('reset_quick_filters');
		});

		$(carousel).on('afterChange', e => {
			checkLastSlide();
		});

		_$lastSlide = $(carousel).find('.slick-slide').last();
	}

	function checkLastSlide() {
		if (_$lastSlide) {
			const _$nextArrow = _$nav.find('.slick-next');
			const hideArrow = isInViewport(_$lastSlide);

			if (hideArrow) {
				_$nextArrow.hide();
			} else {
				_$nextArrow.show();
			}
		}
	}

	function stop() {
		$(_$carousel).slick('unslick');
	}

	function onResize() {
		if (BreakpointSniffer.isBigger('md')) {
			checkLastSlide();

			if (!isActive) {
				start();
			}
		} else {
			if (isActive) {
				stop();
			}
		}
	}

	return {
		init,
	};
})();